import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetReferBookEntryDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/ReferBookEntry/GetDetailByReferBookEntryId?` + params, null);

export const GetReferBookEntryList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/ReferBookEntry/GetList?` + params, null);